import { render, staticRenderFns } from "./TedsLauncherMobileFooter.vue?vue&type=template&id=7a88aaf6&"
import script from "./TedsLauncherMobileFooter.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherMobileFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherMobileFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports